export const AUTH_TOKEN = 'auth:user_token';
